// Init
import React, { lazy, Suspense } from 'react';
import FalconLoader from '../components/Common/FalconLoader';

const NavBar = lazy(() => import('../components/Common/NavBar'));
const ErrorSection = lazy(() => import('../components/Common/ErrorSection'));

export default function ErrorPage() {
  return (
    <div className="ProjectsContainer">
      <Suspense fallback={<FalconLoader />}>
        <NavBar default />
        <ErrorSection />
      </Suspense>
    </div>
  );
}
